import { Checkbox } from "../Checkbox/Checkbox";
import classNames from "classnames";
import { Row } from "react-table-8.10.7";

type VisibilityMode = "always" | "hover" | "onSelect";

export const SelectionCell = <TData,>({
  row,
  visibility = "always",
  hasSelection = false,
  ariaLabel,
  className,
  onClick,
  onChange,
}: {
  row: Row<TData>;
  visibility?: VisibilityMode;
  hasSelection?: boolean;
  ariaLabel?: string;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  const shouldShowCheckbox = () => {
    if (visibility === "always") return true;
    if (visibility === "hover") return true;
    if (visibility === "onSelect") return hasSelection || row.getIsSelected();
    return true;
  };

  if (!shouldShowCheckbox()) return null;

  return (
    <div
      className={classNames(
        "t-flex t-items-center t-transition-opacity",
        {
          "t-opacity-0 group-hover:t-opacity-100 sm:t-opacity-100":
            visibility === "hover" && !hasSelection,

          "t-opacity-100":
            (visibility === "hover" && hasSelection) ||
            (visibility === "onSelect" && hasSelection) ||
            visibility === "always",

          "t-opacity-0": visibility === "onSelect" && !hasSelection,
        },
        className
      )}
      onClick={(e) => e.stopPropagation()}
    >
      <Checkbox
        checked={row.getIsSelected()}
        disabled={!row.getCanSelect()}
        indeterminate={row.getIsSomeSelected()}
        onChange={onChange ?? row.getToggleSelectedHandler()}
        aria-label={ariaLabel}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(e);
        }}
      />
    </div>
  );
};
